import React from 'react';
import { RadarIcon } from 'lucide-react';
type LogoProps = {
  tone?: 'light' | 'dark';
};
export function Logo({
  tone = 'light'
}: LogoProps) {
  return <div className="flex items-center gap-2.5" data-id="element-199" data-mp="8v62cptcae52">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy-900 ring-1 ring-radar/40" data-id="element-200" data-mp="3qacofm8obu1k">
        <RadarIcon className="h-6 w-6 text-radar" aria-hidden="true" data-id="element-201" data-mp="3v9frx2909s7f" />
      </span>
      <span className={`font-display text-xl font-bold uppercase leading-none tracking-wide ${tone === 'dark' ? 'text-white' : 'text-navy-900'}`} data-id="element-202" data-mp="mskzyhtqxs84">
        Implant <span className="text-radar" data-id="element-203" data-mp="dspmg6cpxl4x">Risk Radar</span>
        <sup className="text-[10px]" data-id="element-204" data-mp="du8yfkrcda0w">™</sup>
      </span>
    </div>;
}